import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Dog, Package, ArrowRight, Mail, Copy, Check } from 'lucide-react';
import { Button } from './ui/Button';
export function PackageCards() {
  const [copied, setCopied] = useState(false);
  const handleCopyCode = () => {
    navigator.clipboard.writeText('proberen');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <section className="py-20 bg-white" data-id="element-151">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-153">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-154">
            Zet vandaag de eerste stap
          </h2>
          <p className="text-xl text-gray-600" data-id="element-155">Stap 1: Kies Je Startpakket</p>
        </motion.div>

        {/* Step 1: Packages */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-20 max-w-4xl mx-auto" data-id="element-156">
          {/* Card 1 - Highlighted - Now Clickable */}
          <motion.a href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/284458/proefpakket_hond_400g_1_set_met_verschillende_soorten_natvoer_vlokken_en_testpakketten_?new_client_country=NL&category=62183&refconsultant=487050" target="_blank" rel="noopener noreferrer" whileHover={{
          y: -5
        }} className="border-2 border-[#4DBFB8] bg-[#4DBFB8]/5 rounded-2xl p-8 flex flex-col h-full relative shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer" data-id="element-157">
            <div className="absolute top-0 right-0 bg-[#4DBFB8] text-white text-xs font-bold px-3 py-1 rounded-bl-lg rounded-tr-lg" data-id="element-158">
              AANBEVOLEN
            </div>
            <div className="bg-[#4DBFB8]/20 w-12 h-12 rounded-full flex items-center justify-center mb-6" data-id="element-159">
              <Dog className="w-6 h-6 text-[#4DBFB8]" data-id="element-160" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-161">
              PROEFPAKKET
            </h3>
            <p className="text-gray-600 mb-6 flex-grow" data-id="element-162">
              Diverse blikken om smaken te ontdekken. Perfect als eerste
              kennismaking.
            </p>
            <div className="pt-6 border-t border-[#4DBFB8]/20" data-id="element-163">
              <p className="text-sm font-medium text-gray-500 mb-4" data-id="element-164">
                Ideaal voor:
              </p>
              <p className="text-gray-900 font-medium flex items-center gap-2" data-id="element-165">
                <ArrowRight className="w-4 h-4 text-[#4DBFB8]" data-id="element-166" />
                Nieuwe klanten die willen proberen
              </p>
            </div>
          </motion.a>

          {/* Card 2 - Now Clickable */}
          <motion.a href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/165810?new_client_country=NL&category=62183&refconsultant=487050" target="_blank" rel="noopener noreferrer" whileHover={{
          y: -5
        }} className="border border-gray-200 rounded-2xl p-8 flex flex-col h-full hover:shadow-xl transition-all duration-300 cursor-pointer" data-id="element-167">
            <div className="bg-gray-100 w-12 h-12 rounded-full flex items-center justify-center mb-6" data-id="element-168">
              <Package className="w-6 h-6 text-gray-600" data-id="element-169" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-170">
              STANDAARD OMSCHAKELPAKKET
            </h3>
            <p className="text-gray-600 mb-6 flex-grow" data-id="element-171">
              Compleet pakket met alles voor een volledige overgang.
            </p>
            <div className="pt-6 border-t border-gray-100" data-id="element-172">
              <p className="text-sm font-medium text-gray-500 mb-4" data-id="element-173">
                Ideaal voor:
              </p>
              <p className="text-gray-900 font-medium flex items-center gap-2" data-id="element-174">
                <ArrowRight className="w-4 h-4 text-[#4DBFB8]" data-id="element-175" />
                Wie direct volledig wil overstappen
              </p>
            </div>
          </motion.a>
        </div>

        {/* Steps 2 & 3 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-176">
          {/* Step 2 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gray-50 rounded-2xl p-8" data-id="element-177">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-178">
              Stap 2: 10% Korting
            </h3>
            <div className="space-y-4" data-id="element-179">
              <div className="flex items-start gap-4" data-id="element-180">
                <div className="w-8 h-8 rounded-full bg-[#E85D5D] text-white flex items-center justify-center font-bold flex-shrink-0" data-id="element-181">
                  1
                </div>
                <p className="text-gray-700 pt-1" data-id="element-182">
                  Ga naar de Anifit webshop via onze link
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-183">
                <div className="w-8 h-8 rounded-full bg-[#E85D5D] text-white flex items-center justify-center font-bold flex-shrink-0" data-id="element-184">
                  2
                </div>
                <p className="text-gray-700 pt-1" data-id="element-185">
                  Voeg je producten toe aan de winkelwagen
                </p>
              </div>
              <div className="flex items-start gap-4" data-id="element-186">
                <div className="w-8 h-8 rounded-full bg-[#E85D5D] text-white flex items-center justify-center font-bold flex-shrink-0" data-id="element-187">
                  3
                </div>
                <div className="flex-grow" data-id="element-188">
                  <p className="text-gray-700 pt-1 mb-2" data-id="element-189">
                    Zoek "Heeft u een voucher?" en vul in:
                  </p>
                  <button onClick={handleCopyCode} className="border-2 border-dashed border-[#4DBFB8] bg-white px-4 py-2 rounded-lg inline-flex items-center gap-2 text-[#4DBFB8] font-bold text-lg hover:bg-[#4DBFB8]/5 transition-colors cursor-pointer group" data-id="element-190">
                    <span data-id="element-191">proberen</span>
                    {copied ? <Check className="w-4 h-4" data-id="element-192" /> : <Copy className="w-4 h-4 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-193" />}
                  </button>
                  {copied && <p className="text-sm text-[#4DBFB8] mt-2 font-medium" data-id="element-194">
                      ✓ Code gekopieerd!
                    </p>}
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-195">
                <div className="w-8 h-8 rounded-full bg-[#E85D5D] text-white flex items-center justify-center font-bold flex-shrink-0" data-id="element-196">
                  4
                </div>
                <p className="text-gray-700 pt-1" data-id="element-197">
                  Je 10% korting wordt direct verrekend
                </p>
              </div>
            </div>
          </motion.div>

          {/* Step 3 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#4DBFB8]/10 rounded-2xl p-8" data-id="element-198">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-199">
              Stap 3: Ontvang Je Gratis Voedingsadvies
            </h3>
            <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-200">
              Na je bestelling sturen wij je persoonlijk een email met een
              vragenformulier over de gezondheid van je hond. Hiermee maken wij
              een persoonlijk voedingsplan. Vervolgens beantwoorden wij al je
              vragen en begeleiden wij je verder.
            </p>
            <a href="mailto:amee@stresslessdogs.nl" className="inline-flex items-center gap-3 text-[#4DBFB8] font-bold bg-white px-6 py-3 rounded-lg shadow-sm hover:shadow-md transition-all" data-id="element-201">
              <Mail className="w-5 h-5" data-id="element-202" />
              amee@stresslessdogs.nl
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}